import React, { useCallback } from 'react';
import { useRouter, useLocalSearchParams } from 'expo-router';
import AuthPage from '@/components/Pages/AuthPage';
import MetaHead from '@/components/MetaHead';
import MfaForm from '@/components/Forms/MfaForm';
import { useTranslation } from '@/hooks/useTranslation';

function MfaRoute() {
  const { t } = useTranslation();
  const router = useRouter();
  const params = useLocalSearchParams();

  const handleLogoPress = useCallback(() => {
    router.push('/');
  }, [router]);

  return (
    <AuthPage
      title={t('pages.auth.mfaTitle')}
      subtitle={t('pages.auth.mfaSubtitle')}
      onLogoPress={handleLogoPress}
    >
      <MetaHead 
        title={t('pages.auth.mfaMetaTitle')}
        description={t('pages.auth.mfaMetaDescription')}
        noindex
      />
      <MfaForm ticket={params?.ticket?.toString?.()} email={params?.email?.toString?.()} />
    </AuthPage>
  );
}

export default React.memo(MfaRoute); 